import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { ExportDataSource, ListingExportConfig, ListingPayload } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { mapFieldOperationsSensorsToExport } from './field-operations-sensors-listing.export';
import { FieldOperationsSensorsListItem } from './field-operations-sensors.types';

@Injectable()
export class FieldOperationsSensorsListingExportConfigService implements ListingExportConfig {
  private readonly timezoneService = inject(TimezoneService);

  readonly fileName = 'Export-SensorsFieldOperations';
  readonly dataSource: ExportDataSource<ExportRow[]> = {
    export: (payload: Pick<ListingPayload, 'filters' | 'sort' | 'search'>): Observable<ExportRow[]> =>
      this.fetchItems(payload).pipe(
        map(items =>
          items.flatMap(item => mapFieldOperationsSensorsToExport(item, d => this.timezoneService.formatLong(d)))
        )
      )
  };

  // TODO(#799932): connect to the Sensors field operations export endpoint
  private fetchItems(
    _payload: Pick<ListingPayload, 'filters' | 'sort' | 'search'>
  ): Observable<FieldOperationsSensorsListItem[]> {
    return of([]);
  }
}
